import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionList, OptionListHeight } from '../OptionList';
import { ShowAllButton } from '../ShowAllButton/component';

import { SubtitlesTracksListProps } from './SubtitlesTracksList.types';
import styles from './SubtitlesTracksList.module.css';

export const SubtitlesTracksList: FC<SubtitlesTracksListProps> = ({
    className,
    titleClassName,
    bodyClassName,
    currentTextTrack,
    textTracksWithDisableOption,
    handleSelectTextTrack,
    showAllSubtitles,
    hasMoreSubtitles,
}) => (
    <section className={className}>
        <h1 className={titleClassName}>
            <FormattedMessage
                id="components.PlayerSkin.6a73085e389c48beca8b3f4629b4b1e4"
                defaultMessage="Subtitles"
                description="Заголовок списка субтитров"
            />
        </h1>
        <div className={bodyClassName}>
            <OptionList<string>
                value={currentTextTrack || null}
                onSelect={handleSelectTextTrack}
                options={textTracksWithDisableOption}
                heightType={OptionListHeight.Range}
            />
            {hasMoreSubtitles && (
                <ShowAllButton className={styles.showAllContainer} onClick={showAllSubtitles} />
            )}
        </div>
    </section>
);
